import { useRef } from "react"
import HCaptcha from "@hcaptcha/react-hcaptcha"

interface HCaptchaComponentProps {
  onVerify: (token: string) => void
  onError?: () => void
  onExpire?: () => void
}

export function HCaptchaComponent({ onVerify, onError, onExpire }: HCaptchaComponentProps) {
  const captchaRef = useRef<HCaptcha>(null)
  const siteKey = import.meta.env.VITE_HCAPTCHA_SITE_KEY

  if (!siteKey) {
    console.warn("hCaptcha site key not configured")
    return null
  }

  return (
    <div className="flex justify-center">
      <HCaptcha
        ref={captchaRef}
        sitekey={siteKey}
        onVerify={onVerify}
        onError={onError}
        onExpire={onExpire}
        theme="light"
      />
    </div>
  )
}

